import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import confetti from "canvas-confetti";
import { TransactionSuccessModalContainer } from "./TransactionSuccessModal.styles";
import { HelpCenterIcon } from "assets/icons";

const TransactionSuccessModal = ({
  show,
  onHide,
  type = "deposit", // 'deposit' or 'withdraw'
  amount,
}) => {
  const modalRef = useRef(null);

  const formattedAmount = amount
    ? Math.abs(parseFloat(amount)).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : "0.00";

  // Confetti effect - same implementation as InvestmentOrderCard
  useEffect(() => {
    if (!show || !modalRef.current) return;

    const canvas = document.createElement("canvas");
    canvas.style.position = "absolute";
    canvas.style.top = 0;
    canvas.style.left = 0;
    canvas.style.width = "100%";
    canvas.style.height = "100%";
    canvas.style.pointerEvents = "none";
    modalRef.current.appendChild(canvas);

    const myConfetti = confetti.create(canvas, { resize: true });
    const count = 200;
    const defaults = { origin: { y: 0.7 } };

    function fire(particleRatio, opts) {
      myConfetti({
        ...defaults,
        ...opts,
        particleCount: Math.floor(count * particleRatio),
      });
    }

    // Fire sequence
    fire(0.25, { spread: 26, startVelocity: 55 });
    fire(0.2, { spread: 60 });
    fire(0.35, { spread: 100, decay: 0.91, scalar: 0.8 });
    fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 });
    fire(0.1, { spread: 120, startVelocity: 45 });

    return () => {
      myConfetti.reset();
      if (canvas.parentNode) {
        canvas.parentNode.removeChild(canvas);
      }
    };
  }, [show]);

  const isDeposit = type === "deposit";

  return (
    <TransactionSuccessModalContainer show={show} onHide={onHide}>
      <div className="modal-header">
        <h2 className="modal-title">
          {isDeposit ? "Deposit funds" : "Withdraw funds"}
        </h2>
      </div>

      <div className="modal-body-content" ref={modalRef}>
        <div className="content-wrapper">
          {/* Success Title */}
          <h3 className="success-title">
            {isDeposit ? "Deposit successful!" : "Withdraw successful!"}
          </h3>

          {/* Success Message */}
          <p className="success-message">
            <span className="amount">${formattedAmount}</span> has been{" "}
            {isDeposit ? "deposited to" : "withdrawn from"} your Surmount
            account
          </p>

          {/* Info Banner */}
          <div className="info-banner">
            <div className="info-icon">
              <HelpCenterIcon />
            </div>
            <p className="info-text">
              You can check your pending {isDeposit ? "deposit" : "withdraw"} on
              Dashboard.
            </p>
          </div>

          {/* Finish Button */}
          <button className="finish-button" onClick={onHide}>
            Finish
          </button>
        </div>
      </div>
    </TransactionSuccessModalContainer>
  );
};

TransactionSuccessModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  type: PropTypes.oneOf(["deposit", "withdraw"]).isRequired,
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export { TransactionSuccessModal };
